import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';
import signals from './lib/signals.js';

export class MessageForm {
	constructor(parent, provider) {
		[this.el, this.$] = DojoTemplates('MessageForm');
		this.provider = provider;
		Eventify(this.el,  {
			'Send':function(evt) {
				console.log(`In MessageForm.Send`);
				evt.preventDefault();
				evt.stopPropagation();
				let p = null;
				let rpc = DojoDeshi.instance().RPC();
				let ids = this.provider.idArray();
				if  (this.isSms()) {
					p = rpc.SendShortMessage(ids, this.$.msgText.value);
				} else {
					p = rpc.SendEmailMessage(ids, this.$.msgTitle.value, this.$.msgText.value);
				}
				p.then(
						(res)=>{
							jQuery(this.el).foundation('close');
						})
					.catch( 
						(err)=>{
							alert(`ERROR: ${err.message}`);
							console.error("ERROR on SendShortMessage: ", err);
						});
			},
			'messageChange':function(evt) {
				this.$.characterCount.textContent = `(${this.$.msgText.value.length} chars)`;
			},
			'smsOrEmailToggle':function(evt) {
				this.$.titleDiv.style.display = (this.isSms() ? 'none' : 'block');
			}
		}, this);
		parent.appendChild(this.el);

		// jQuery(this.el).foundation();
	}
	open() {
		// jQuery(this.el).foundation('open');
	}
	isSms() {
		return this.$.smsMessage.checked;
	}
}